export default {
  initialize(browse) {
    this.browse = browse;
    // TODO: understand this use case
    // $(document).on('tree:sidebar:load', () => { this.handleSidebarLoad(); });

    $(document).on('tree:node:changed', this.handleNodeChanged.bind(this));
    $(document).on('tree:nodes:changed', this.handleMultiNodesChanged.bind(this));
    $(document).on('tree:node:nameChanged', this.handleNodeNameChanged.bind(this));
    $(document).on('tree:childNodes:sorted', this.handleChildNodesSorted.bind(this));
    $(document).on('tree:node:deleted', this.handleNodeDeleted.bind(this));

    // $(document).on('click', 'a[data-new-child]', (e) => {
    //   const node = this.tree.findNode($(e.target).data('new-child'));
    //   this.showNewChildModal(node);
    //   e.preventDefault();
    // });
  },

  destroy() {
    $(document).off('tree:node:changed', this.handleNodeChanged);
    $(document).off('tree:nodes:changed', this.handleMultiNodesChanged);
    $(document).off('tree:node:nameChanged', this.handleNodeNameChanged);
    $(document).off('tree:childNodes:sorted', this.handleChildNodesSorted);
    $(document).off('tree:node:deleted', this.handleNodeDeleted);
  },

  handleNodeChanged(e, node, childNode) {
    this.browse.tree.reloadNode(node.uuid, (treeNode) => {
      treeNode.setExpanded(true);

      // If the sidebar is open with the changed node or its parent, reload the sidebar content
      const parentUuid = (treeNode.parent || {}).data && treeNode.parent.data.uuid;
      const sidebarNodeUuid = this.browse.state.sidebarNode && this.browse.state.sidebarNode.uuid;
      const childNodeUuid = childNode && childNode.uuid;

      if (sidebarNodeUuid === node.uuid || sidebarNodeUuid === parentUuid || sidebarNodeUuid === childNodeUuid) {
        this.browse.reloadSidebar();
      }

      if (childNode) {
        this.browse.tree.setCurrent(childNodeUuid);

        if (this.browse._pendingHighlightNode === childNodeUuid) {
          this.browse.highlightNewNode(childNode);
          delete this.browse._pendingHighlightNode;
        }
      } else if (this.browse._pendingHighlightParent === node.uuid) {
        const children = treeNode.getChildren();
        if (children && children.length > 0) {
          const lastChild = children[children.length - 1];
          this.browse.highlightNewNode(lastChild.data);
          delete this.browse._pendingHighlightParent;
        }
      }

      // Reload the current datatable if is changed the current node
      if (childNode) {
        this.browse.visitNode(childNode);
      } else if (node.uuid === this.browse.state.current_uuid) {
        this.browse.visitNode(node);
      }
    });
  },

  handleMultiNodesChanged(e, parent, nodes) {
    this.browse.tree.reloadNode(parent.uuid, (treeNode) => {
      treeNode.setExpanded(true);

      const sidebarNodeUuid = this.browse.state.sidebarNode && this.browse.state.sidebarNode.uuid;
      if (sidebarNodeUuid === parent.uuid) {
        this.browse.reloadSidebar();
      }

      if (Array.isArray(nodes) && nodes.length > 0) {
        nodes.forEach(node => {
          this.browse.highlightNewNode(node);
        });

        this.browse.tree.setCurrent(nodes[0].uuid);

        this.browse.visitNode(nodes[0]);
      }
    });
  },

  handleNodeNameChanged(e, node, newName) {
    const parentUuid = (node.parent || {}).data && node.parent.data.uuid;
    if(!parentUuid){ $('.root-info__name h2').text(newName); }
    $('.editable-bundle-general-title').text(newName);
    node.setTitle(newName);
  },

  handleChildNodesSorted(e, node) {
    this.browse.tree.reloadNode(node.uuid, treeNode => {
      treeNode.setExpanded(true);
    });
  },

  handleNodeDeleted(e, node, parent) {
    this.browse.visitNode(parent);
    this.browse.tree.removeNode(node.uuid);
  }
};
